var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.deferredPrompt)?_c('button',{ref:"addBtn",staticClass:"add-button",on:{"click":_vm.clickCallback}},[_vm._v(" Add ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }